<div *ngIf="mappedChartDatasetsReady">

    <div #canvasContainer class="canvas-container">

        <canvas baseChart
                [datasets]="mappedChartDatasets"
                [labels]="mappedChartAxisLabels"
                [legend]="chartLegend"
                [options]="chartOptions"
                [type]="chartType">
        </canvas>
    </div>

    <div *ngIf="mappedTableValuesReady && tableDataAvailable">

        <p-dialog [header]="tableTitle"
                  [modal]="true"
                  [(visible)]="tableDialogOpen"
                  [style]="{ height: '90%', width: '90%' }">

            <table>
                <thead>
                <tr>

                    <th class="group">{{ tableGroupColumnLabel }}</th>

                    <ng-container *ngIf="multipleDataPoints">
                        <ng-container *ngFor="let dataPoint of array(chartData)">

                            <th class="duration">{{ dataPoint.tableColumnLabel }}</th>

                        </ng-container>
                    </ng-container>

                    <th class="sum">(Sum)</th>
                    <th class="min">(Min)</th>
                    <th class="max">(Max)</th>
                    <th class="avg">(Avg)</th>

                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let entry of mappedTableValues">
                    <tr>

                        <td class="group">{{ entry.group }}</td>

                        <ng-container *ngIf="multipleDataPoints">
                            <ng-container *ngFor="let _ of array(chartData); let i = index">

                                <td class="duration">
                                    <ng-container *ngIf="entry.individual![i]">
                                        {{ entry.individual![i].sum  | toSeconds | readableSeconds }}
                                    </ng-container>
                                </td>

                            </ng-container>
                        </ng-container>

                        <td class="sum">{{ entry.sum | toSeconds | readableSeconds }}</td>
                        <td class="min">{{ entry.min | toSeconds | readableSeconds }}</td>
                        <td class="max">{{ entry.max | toSeconds | readableSeconds }}</td>
                        <td class="avg">{{ entry.avg | toSeconds | readableSeconds }}</td>

                    </tr>
                </ng-container>
                </tbody>
            </table>

        </p-dialog>

        <p-contextmenu [model]="canvasContextMenuItems"
                       [target]="canvasContainer"
                       [appendTo]="'body'"></p-contextmenu>
    </div>

</div>
